<template>
    <div class="layout-px-spacing dash_1">
        <teleport v-if="allowBreadcrumbTeleport" to="#breadcrumb">
            <ul class="navbar-nav flex-row">
                <li>
                    <div class="page-header">
                        <nav class="breadcrumb-one" aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="javascript:;">Painel inicial</a></li>
                                <li class="breadcrumb-item active" aria-current="page"><span>Visão geral</span></li>
                            </ol>
                        </nav>
                    </div>
                </li>
            </ul>
        </teleport>

        <div class="dashboard-coupon-prompt">
            <PendingSubscriptionCouponPrompt variant="card" />
        </div>

        <div class="row dashboard-main-row">
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                <div class="row layout-top-spacing">
                    <div class="col-12 layout-spacing">
                        <div class="widget widget-transaction widget-skeleton-container dashboard-card-equal" :class="{ 'is-loading-turmas': loadingTurmas }">
                            <div class="widget-heading">
                                <h5>Turmas recentes</h5>
                            </div>

                            <div class="widget-content">
                                <!-- Esqueleto para turmas -->
                                <div v-if="loadingTurmas" class="skeleton-container">
                                    <div v-for="i in 4" :key="i" class="skeleton-turma">
                                        <div class="skeleton-circle"></div>
                                        <div class="skeleton-content">
                                            <div class="skeleton-line skeleton-line-title"></div>
                                            <div class="skeleton-line skeleton-line-info"></div>
                                        </div>
                                    </div>
                                </div>
                                <template v-else v-for="turma in redacaoStatsStore.getEstatisticasPorTurma" :key="turma.nome">
                                    <div class="transactions-list" style="cursor: pointer" @click="irParaTurma( turma.nome, turma.id )">
                                        <div>
                                            <span class="b-avatar me-2 rounded-circle" :style="{ backgroundColor: getInitialColor(turma.nome) }">
                                                <span class="b-avatar-text">
                                                    <span>{{ getInitials(turma.nome) }}</span>
                                                </span>
                                            </span>
                                            <div class="t-name">
                                                <h4>{{ turma.nome }}</h4>
                                                <p>
                                                    <span class="status-dot yellow"></span>{{ turma.pendentes }} Pendentes
                                                    <span class="status-dot green ms-3"></span>{{ turma.corrigidas }} Corrigidas
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                
                                <!-- Mensagem para quando não houver turmas -->
                                <div v-if="!loadingTurmas && redacaoStatsStore.getEstatisticasPorTurma.length === 0" class="empty-state-container">
                                    <div class="empty-state-content">
                                        <h5 class="empty-state-title">Nenhuma turma encontrada</h5>
                                        <p class="empty-state-description">
                                            Suas turmas recentes aparecerão aqui.
                                        </p>
                                        <button class="btn btn-primary empty-state-button" @click="irParaCadastroTurma">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus me-2">
                                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                            </svg>
                                            Cadastrar uma nova turma
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                        <div class="widget widget-sales-category widget-skeleton-container">
                            <div class="widget-heading">
                                <h5>Suas correções{{ periodoTexto ? ' - ' + periodoTexto : '' }}</h5>
                                <div class="dropdown btn-group">
                                    <a href="javascript:;" id="checkPeriodoCorrecoes" class="btn dropdown-toggle btn-icon-only" data-bs-toggle="dropdown" aria-expanded="false">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="feather feather-more-horizontal"
                                        >
                                            <circle cx="12" cy="12" r="1"></circle>
                                            <circle cx="19" cy="12" r="1"></circle>
                                            <circle cx="5" cy="12" r="1"></circle>
                                        </svg>
                                    </a>
                                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="checkPeriodoCorrecoes">
                                        <li>
                                            <a href="javascript:;" class="dropdown-item" :class="{ active: redacaoStatsStore.getPeriodoAtual === 'este_mes' }" @click="alterarPeriodo('este_mes')">
                                                Este mês
                                                <svg v-if="redacaoStatsStore.getPeriodoAtual === 'este_mes'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check float-end">
                                                    <polyline points="20 6 9 17 4 12"></polyline>
                                                </svg>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:;" class="dropdown-item" :class="{ active: redacaoStatsStore.getPeriodoAtual === 'este_ano' }" @click="alterarPeriodo('este_ano')">
                                                Este ano
                                                <svg v-if="redacaoStatsStore.getPeriodoAtual === 'este_ano'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check float-end">
                                                    <polyline points="20 6 9 17 4 12"></polyline>
                                                </svg>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:;" class="dropdown-item" :class="{ active: redacaoStatsStore.getPeriodoAtual === 'tudo' }" @click="alterarPeriodo('tudo')">
                                                Tudo
                                                <svg v-if="redacaoStatsStore.getPeriodoAtual === 'tudo'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check float-end">
                                                    <polyline points="20 6 9 17 4 12"></polyline>
                                                </svg>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="widget-content">
                                <!-- Esqueleto para o gráfico -->
                                <div v-if="loadingGrafico" class="skeleton-chart">
                                    <div class="skeleton-donut">
                                        <div class="skeleton-donut-hole"></div>
                                    </div>
                                    <div class="skeleton-legend">
                                        <div class="skeleton-legend-item"></div>
                                        <div class="skeleton-legend-item"></div>
                                        <div class="skeleton-legend-item"></div>
                                    </div>
                                </div>
                                <div v-else-if="chartError" class="chart-error-container">
                                    <p>Erro ao carregar o gráfico. <button class="btn btn-sm btn-primary" @click="recarregarGrafico">Tentar novamente</button></p>
                                </div>
                                <div v-else-if="chartsVisible && chartReady && options_7 && series_7.length > 0" class="chart-container chart-container-correcoes">
                                    <apex-chart ref="chartCorrecoesRef" height="220" type="donut" :options="options_7"
                                        :series="series_7" @error="handleChartError"></apex-chart>
                                </div>
                                <div v-else class="no-data-container">
                                    <p>Nenhuma estatística disponível.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                <div class="row layout-top-spacing" style="margin-top: 12px !important;">
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 layout-spacing">
                        <div class="dashboard-card-equal">
                            <DashboardFilaCorrecoesRevisoes
                                :itens-correcoes="filaCorrecoesFormatada"
                                :loading-correcoes="loadingFilaCorrecoes"
                                :on-correcao-click="irParaCorrecao"
                                :on-empty-correcoes-click="irParaEnviarRedacao"
                            />
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 layout-spacing">
                        <div class="dashboard-card-equal">
                            <FinanceiroCard />
                        </div>
                    </div>  
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                    <div class="widget widget-revenue widget-skeleton-container">
                        <div class="widget-heading">
                             <h5>Estatísticas de redações</h5><small class="text-muted">{{ new Date().getFullYear() }}</small>
                             <!--
                            <div class="dropdown btn-group">
                                <a href="javascript:;" id="ddlRevenue" class="btn dropdown-toggle btn-icon-only" data-bs-toggle="dropdown" aria-expanded="false">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-more-horizontal"
                                    >
                                        <circle cx="12" cy="12" r="1"></circle>
                                        <circle cx="19" cy="12" r="1"></circle>
                                        <circle cx="5" cy="12" r="1"></circle>
                                    </svg>
                                </a>
                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="ddlRevenue">
                                    <li><a href="javascript:;" class="dropdown-item">Semana</a></li>
                                    <li><a href="javascript:;" class="dropdown-item">Mês</a></li>
                                    <li><a href="javascript:;" class="dropdown-item">Ano</a></li>
                                </ul>
                            </div>
                            -->
                        </div>
                        <div class="widget-content">
                            <!-- Esqueleto para o gráfico mensal -->
                            <div v-if="loadingGraficoMensal" class="skeleton-area-chart-container">
                                <div class="skeleton-area-chart">
                                    <svg class="skeleton-chart-svg" viewBox="0 0 400 150" preserveAspectRatio="none">
                                        <defs>
                                            <linearGradient id="skeletonGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                                <stop offset="0%" stop-color="currentColor" stop-opacity="0.3">
                                                    <animate attributeName="stop-opacity" values="0.3;0.6;0.3" dur="2s" repeatCount="indefinite"/>
                                                </stop>
                                                <stop offset="50%" stop-color="currentColor" stop-opacity="0.5">
                                                    <animate attributeName="stop-opacity" values="0.5;0.8;0.5" dur="2s" repeatCount="indefinite"/>
                                                </stop>
                                                <stop offset="100%" stop-color="currentColor" stop-opacity="0.3">
                                                    <animate attributeName="stop-opacity" values="0.3;0.6;0.3" dur="2s" repeatCount="indefinite"/>
                                                </stop>
                                            </linearGradient>
                                        </defs>
                                        <!-- Linha do gráfico simulada -->
                                        <path d="M 0,120 Q 50,80 100,90 T 200,70 T 300,50 T 400,40" 
                                              stroke="url(#skeletonGradient)" 
                                              stroke-width="2.5" 
                                              fill="none" 
                                              stroke-linecap="round"/>
                                        <path d="M 0,120 Q 50,80 100,90 T 200,70 T 300,50 T 400,40 L 400,150 L 0,150 Z" 
                                              fill="url(#skeletonGradient)" 
                                              opacity="0.2"/>
                                    </svg>
                                </div>
                            </div>
                            <div v-else-if="chartMensalError" class="chart-error-container">
                                <p>Erro ao carregar o gráfico mensal. <button class="btn btn-sm btn-primary" @click="recarregarGraficoMensal">Tentar novamente</button></p>
                            </div>
                            <div v-else-if="chartsVisible && revenue_options && revenue_series && revenue_series.length > 0 && hasValidData" class="chart-container">
                                <apex-chart ref="chartMensalRef" height="230" type="area" :options="revenue_options" :series="revenue_series" @error="handleChartError"></apex-chart>
                            </div>
                            <div v-else class="empty-state-container empty-state-chart">
                                <div class="empty-state-content">
                                    <div class="empty-state-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-bar-chart-2">
                                            <line x1="18" y1="20" x2="18" y2="10"></line>
                                            <line x1="12" y1="20" x2="12" y2="4"></line>
                                            <line x1="6" y1="20" x2="6" y2="14"></line>
                                        </svg>
                                    </div>
                                    <h5 class="empty-state-title">Ainda não há dados para este período</h5>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import "../assets/sass/widgets/widgets.scss";
import { computed, onMounted, onBeforeUnmount, ref, onErrorCaptured, nextTick, watch } from "vue";
import { useStore } from "vuex";
import { useRouter, onBeforeRouteLeave } from 'vue-router';
import ApexChart from "vue3-apexcharts";
import { waitForChartDomReady, isBenignApexChartsNavigationReason } from '@/utils/apexChartsBenign';
import { useRedacaoStatsStore } from '@/stores/redacaoStats';
import { isValidDocumentoApiId } from '@/stores/documento';
import FinanceiroCard from '@/components/widgets/FinanceiroCard.vue';
import DashboardFilaCorrecoesRevisoes from '@/components/widgets/DashboardFilaCorrecoesRevisoes.vue';
import PendingSubscriptionCouponPrompt from '@/components/subscription/PendingSubscriptionCouponPrompt.vue';
import { useUserDashboardPreferencesStore } from '@/stores/userDashboardPreferences';
import { useMeta } from "../composables/use-meta";
useMeta({ title: "Visão geral" });

const store = useStore();
const nomeUsuario = computed(() => store.getters['auth/StateUser'].name);

const router = useRouter();
const dashboardPrefs = useUserDashboardPreferencesStore();
const allowBreadcrumbTeleport = ref(true);

const redacaoStatsStore = useRedacaoStatsStore();

// Estados de loading
const loadingTurmas = ref(false);
const loadingGrafico = ref(false);
const loadingGraficoMensal = ref(false);
const loadingFilaCorrecoes = ref(true); // Inicia como true para mostrar skeleton imediatamente
const chartReady = ref(false);
const chartError = ref(false);
const chartMensalError = ref(false);
/** Desliga os gráficos antes da troca de rota para o ApexCharts não atualizar DOM já removido. */
const chartsVisible = ref(true);
const chartCorrecoesRef = ref(null);
const chartMensalRef = ref(null);

const destroyDashboardCharts = () => {
    try {
        chartCorrecoesRef.value?.destroy?.();
    } catch {
        /* instância já destruída ou DOM inválido */
    }
    try {
        chartMensalRef.value?.destroy?.();
    } catch {
        /* idem */
    }
};

/** Desmonta gráficos antes de navegar (evita ApexCharts acessar baseEl já removido). */
const teardownDashboardChartsForNavigation = () => {
    chartsVisible.value = false;
    chartReady.value = false;

    document
        .querySelectorAll('.chart-container .apexcharts-canvas, .chart-container .apexcharts-svg')
        .forEach((el) => {
            el.style.pointerEvents = 'none';
        });

    destroyDashboardCharts();
};

onBeforeRouteLeave(async () => {
    allowBreadcrumbTeleport.value = false;
    teardownDashboardChartsForNavigation();
    await nextTick();
});

onBeforeUnmount(() => {
    allowBreadcrumbTeleport.value = false;
    teardownDashboardChartsForNavigation();
});

watch(
    () => dashboardPrefs.isNewDashboardActive,
    async (active) => {
        if (!active) return;
        // Desliga Teleport antes de sair — evita parentNode null ao trocar o shell
        allowBreadcrumbTeleport.value = false;
        teardownDashboardChartsForNavigation();
        await nextTick();
        if (router.currentRoute.value.name !== 'dashboard') {
            await router.replace({ name: 'dashboard' });
        }
    }
);

// Computed para formatar a fila de correções com tempo de espera
const filaCorrecoesFormatada = computed(() => {
    return redacaoStatsStore.getFilaCorrecoes.map(correcao => {
        const tempoEspera = calcularTempoEspera(correcao.data_submissao);
        return {
            ...correcao,
            tempoEspera
        };
    });
});

// Função para calcular tempo de espera
const calcularTempoEspera = (dataSubmissao) => {
    if (!dataSubmissao) return 'Data não disponível';
    
    const agora = new Date();
    const submissao = new Date(dataSubmissao);
    const diffInSeconds = Math.floor((agora - submissao) / 1000);
    
    if (diffInSeconds < 60) {
        return 'agora';
    }
    
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
        return `há ${diffInMinutes} ${diffInMinutes === 1 ? 'minuto' : 'minutos'}`;
    }
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
        return `há ${diffInHours} ${diffInHours === 1 ? 'hora' : 'horas'}`;
    }
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
        return `há ${diffInDays} ${diffInDays === 1 ? 'dia' : 'dias'}`;
    }
    
    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
        return `há ${diffInMonths} ${diffInMonths === 1 ? 'mês' : 'meses'}`;
    }
    
    const diffInYears = Math.floor(diffInMonths / 12);
    return `há ${diffInYears} ${diffInYears === 1 ? 'ano' : 'anos'}`;
};

const irParaCorrecao = (correcao) => {
    if (!isValidDocumentoApiId(correcao?.id)) return;
    router.push(`/documento/preview/${correcao.id}`);
};

const revenue_series = computed(() => {
    const estatisticasMensais = redacaoStatsStore.getEstatisticasMensais;
    
    if (!estatisticasMensais || estatisticasMensais.length === 0) {
        return [
            { name: "Recebidas", data: [] },
            { name: "Corrigidas", data: [] },
            { name: "Corrigidas por IA", data: [] },
            { name: "Corrigidas por Professores", data: [] }
        ];
    }

    // Ordenar por mês para garantir a ordem correta
    const estatisticasOrdenadas = [...estatisticasMensais].sort((a, b) => a.mes - b.mes);
    
    return [
        { 
            name: "Recebidas", 
            data: estatisticasOrdenadas.map(item => item.redacoes_recebidas || 0) 
        },
        { 
            name: "Corrigidas", 
            data: estatisticasOrdenadas.map(item => item.redacoes_corrigidas || 0) 
        },
        { 
            name: "Corrigidas por IA", 
            data: estatisticasOrdenadas.map(item => item.redacoes_corrigidas_por_ia || 0) 
        },
        { 
            name: "Corrigidas por Professores", 
            data: estatisticasOrdenadas.map(item => item.redacoes_corrigidas_por_professor || 0) 
        }
    ];
});

// Verifica se há dados válidos (pelo menos um valor maior que zero)
const hasValidData = computed(() => {
    const series = revenue_series.value;
    
    if (!series || series.length === 0) {
        return false;
    }
    
    // Verifica se há pelo menos um valor maior que zero em todas as séries
    for (const serie of series) {
        if (serie.data && serie.data.length > 0) {
            const hasNonZeroValue = serie.data.some(value => value > 0);
            if (hasNonZeroValue) {
                return true;
            }
        }
    }
    
    return false;
});

const revenue_labels = computed(() => {
    const estatisticasMensais = redacaoStatsStore.getEstatisticasMensais;
    
    if (!estatisticasMensais || estatisticasMensais.length === 0) {
        return ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
    }

    // Ordenar por mês e pegar apenas os 3 primeiros caracteres do nome do mês
    const estatisticasOrdenadas = [...estatisticasMensais].sort((a, b) => a.mes - b.mes);
    return estatisticasOrdenadas.map(item => item.nome_mes.substring(0, 3));
});
const revenue_options = computed(() => {
    const is_dark = store.state.is_dark_mode;
    return {
        chart: {
            fontFamily: "Nunito, sans-serif",
            zoom: { enabled: false },
            toolbar: { show: false },
        },
        dataLabels: { enabled: false },
        stroke: { show: true, curve: "smooth", width: 2, lineCap: "square" },
        dropShadow: { enabled: true, opacity: 0.2, blur: 10, left: -7, top: 22 },
        colors: is_dark ? ["#2196f3", "#4caf50", "#ff9800", "#9c27b0"] : ["#1b55e2", "#4caf50", "#ff9800", "#9c27b0"],

        labels: revenue_labels.value,
        xaxis: {
            axisBorder: { show: false },
            axisTicks: { show: false },
            crosshairs: { show: true },
            labels: { offsetX: 0, offsetY: 5, style: { fontSize: "12px", fontFamily: "Nunito, sans-serif", cssClass: "apexcharts-xaxis-title" } },
        },
        yaxis: {
            tickAmount: 7,
                         labels: {
                 formatter: function (value) {
                     return value;
                 },
                offsetX: -10,
                offsetY: 0,
                style: { fontSize: "12px", fontFamily: "Nunito, sans-serif", cssClass: "apexcharts-yaxis-title" },
            },
        },
        grid: {
            borderColor: is_dark ? "#191e3a" : "#e0e6ed",
            strokeDashArray: 5,
            xaxis: { lines: { show: true } },
            yaxis: { lines: { show: false } },
            padding: { top: 0, right: 0, bottom: 0, left: 0 },
        },
        legend: {
            position: "top",
            horizontalAlign: "right",
            offsetY: 0,
            fontSize: "16px",
            fontFamily: "Nunito, sans-serif",
            markers: { width: 10, height: 10, strokeWidth: 0, strokeColor: "#fff", fillColors: undefined, radius: 12, onClick: undefined, offsetX: 0, offsetY: 0 },
            itemMargin: { horizontal: 20, vertical: 5 },
        },
        tooltip: { theme: "dark", marker: { show: true }, x: { show: false } },
        fill: {
            type: "gradient",
            gradient: {
                type: "vertical",
                shadeIntensity: 1,
                inverseColors: !1,
                opacityFrom: is_dark ? 0.19 : 0.28,
                opacityTo: 0.05,
                stops: is_dark ? [100, 100] : [45, 100],
            },
        },
    };
});

const options_7 = computed(() => {
    const is_dark = store.state.is_dark_mode;
    return {
        chart: { 
            toolbar: { show: false },
            events: {
                dataPointSelection(_event, _chartContext, config) {
                    const dataPointIndex = config.dataPointIndex;
                    const labels = ["Pendentes", "Você", "IA"];
                    const selectedLabel = labels[dataPointIndex];
                    const routesByLabel = {
                        Pendentes: { name: 'documentos', query: { status: 'pendente,em_correcao' } },
                        Você: { name: 'documentos', query: { status: 'corrigido' } },
                        IA: { name: 'documentos', query: { status: 'corrigido', tipo: 'ia' } },
                    };
                    const target = routesByLabel[selectedLabel];
                    if (!target) return;

                    teardownDashboardChartsForNavigation();
                    router.push(target);
                },
            }
        },
        responsive: [{ breakpoint: 480, options: { chart: { width: 200 }, legend: { position: 'bottom' } } }],
        colors: is_dark ? ["#e2a03f", "#00c853", "#2196f3"] : ["#e2a03f", "#00c853", "#2196f3"],
        labels: ["Pendentes", "Você", "IA"],
        dataLabels: { enabled: false },
        legend: {
            position: "bottom",
            horizontalAlign: "center",
            fontSize: "13px",
            markers: { width: 10, height: 10 },
            height: 32,
            offsetY: 0,
            offsetX: 0,
            itemMargin: { horizontal: 8, vertical: 0 },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "65%",
                    background: "transparent",
                    labels: {
                        show: true,
                        name: { show: true, fontSize: "24px", fontFamily: "Nunito, sans-serif", offsetY: -8 },
                        value: {
                            show: true,
                            fontSize: "22px",
                            fontFamily: "Nunito, sans-serif",
                            color: is_dark ? "#bfc9d4" : undefined,
                            offsetY: 12,
                            formatter: function (val) {
                                return Math.round(val);
                            },
                        },
                        total: {
                            show: true,
                            label: "Total",
                            color: "#888ea8",
                            fontSize: "20px",
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce(function (a, b) {
                                    return a + b;
                                }, 0);
                            },
                        },
                    },
                },
            },
        },
    };
});

const series_7 = computed(() => {
    const pendentes = redacaoStatsStore.getTotalPendentes || 0;
    const corrigidas = redacaoStatsStore.getTotalCorrigidas || 0;
    const corrigidasIA = redacaoStatsStore.getTotalCorrigidasIA || 0;
    return [pendentes, corrigidas, corrigidasIA];
});

// Computed para formatar o texto do período no título
const periodoTexto = computed(() => {
    const periodo = redacaoStatsStore.getPeriodoAtual;
    const periodosMap = {
        'este_mes': 'Este mês',
        'este_ano': 'Este ano',
        'tudo': 'Tudo'
    };
    return periodosMap[periodo] || '';
});

// Função para alterar o período
const alterarPeriodo = async (periodo) => {
    loadingGrafico.value = true;
    chartError.value = false;
    chartReady.value = false;
    
    try {
        await redacaoStatsStore.fetchEstatisticas(periodo);
        await nextTick();
        await waitForChartDomReady();
        chartReady.value = true;
        loadingGrafico.value = false;
    } catch (error) {
        console.error('Erro ao carregar estatísticas:', error);
        chartError.value = true;
        loadingGrafico.value = false;
    }
};

onMounted(async () => {
    loadingGrafico.value = true;
    loadingGraficoMensal.value = true;
    loadingTurmas.value = true;
    loadingFilaCorrecoes.value = true; // Garantir que está true desde o início
    chartError.value = false;
    chartMensalError.value = false;
    
    try {
        await redacaoStatsStore.fetchEstatisticas('este_mes'); // Período padrão
        await nextTick();
        await waitForChartDomReady();
        chartReady.value = true;
        loadingGrafico.value = false;
    } catch (error) {
        console.error('Erro ao carregar estatísticas:', error);
        chartError.value = true;
        loadingGrafico.value = false;
    }
    
    try {
        await redacaoStatsStore.fetchEstatisticasMensais();
    } catch (error) {
        console.error('Erro ao carregar estatísticas mensais:', error);
        chartMensalError.value = true;
    } finally {
        loadingGraficoMensal.value = false;
    }
    
    try {
        await redacaoStatsStore.fetchEstatisticasPorTurma();
    } catch (error) {
        console.error('Erro ao carregar turmas:', error);
    } finally {
        loadingTurmas.value = false;
    }
    
    try {
        await redacaoStatsStore.fetchFilaCorrecoes();
    } catch (error) {
        console.error('Erro ao carregar fila de correções:', error);
    } finally {
        loadingFilaCorrecoes.value = false;
    }
});



const eventoAgora = (evento) => {
    const agora = new Date();
    const inicio = new Date(evento.start);
    const fim = new Date(evento.end);

    // Verifica se o evento está acontecendo agora
    if (agora >= inicio && agora <= fim) {
        return true;
    }

    return false;
};

const eventoClass = (evento) => {
    let classe = '';

    switch (evento.tipo) {
        case 'importante':
            classe = 't-danger';
            break;
        case 'consulta':
            classe = 't-success';
            break;
        default:
            classe = 't-warning';
    }

    // Verifica se o evento está acontecendo agora
    if (eventoAgora(evento)) {
        classe = 't-primary t-pulse';
    }

    if (evento.cancelado) {
        classe = 't-danger';
    }

    return classe;
};

// Função para gerar iniciais a partir de um nome
const getInitials = (nome) => {
    if (!nome || typeof nome !== 'string') return '';

    // Remove espaços extras e divide
    const palavras = nome.trim().split(/\s+/);

    if (palavras.length >= 2) {
        // Pega a primeira letra das duas primeiras palavras
        return (palavras[0][0] + palavras[1][0]).toUpperCase();
    } else if (palavras.length === 1 && palavras[0].length > 0) {
        // Pega as duas primeiras letras da única palavra
        return palavras[0].substring(0, 2).toUpperCase();
    }

    return '';
};


// Função para gerar um número consistente baseado em uma string
const hashCode = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    return Math.abs(hash);
};

// Função para gerar uma cor pastel baseada nas iniciais
const getInitialColor = (nome) => {
    const initials = getInitials(nome);
    const hash = hashCode(initials);
    
    // Lista de cores pastel pré-definidas
    const colors = [
        '#B19CD9', // Lavanda médio
        '#FFB6C1', // Rosa claro
        '#87CEEB', // Azul céu
        '#98FB98', // Verde pálido
        '#DEB887', // Marrom claro
        '#F0E68C', // Cáqui
        '#ADD8E6', // Azul claro
        '#DDA0DD', // Ameixa médio
        '#87CEFA', // Azul claro brilhante
        '#90EE90', // Verde claro
        '#FFA07A', // Salmão claro
        '#B0C4DE', // Azul aço claro
    ];
    
    // Usa o hash para selecionar uma cor consistentemente
    return colors[hash % colors.length];
};

const irParaTurma = (nome, id) => {
    router.push({ name: 'documentos', query: { turma_id: id, busca: nome } });
};

const irParaCadastroTurma = () => {
    router.push({ name: 'turma' });
};

const irParaEnviarRedacao = () => {
    router.push({ name: 'documento' });
};

// Função para recarregar o gráfico em caso de erro
const recarregarGrafico = async () => {
    chartError.value = false;
    loadingGrafico.value = true;
    chartReady.value = false;

    try {
        await redacaoStatsStore.fetchEstatisticas(redacaoStatsStore.getPeriodoAtual);
        await nextTick();
        await waitForChartDomReady();
        chartReady.value = true;
        loadingGrafico.value = false;
    } catch (error) {
        chartError.value = true;
        console.error('Erro ao recarregar estatísticas:', error);
        loadingGrafico.value = false;
    }
};

// Função para recarregar o gráfico mensal em caso de erro
const recarregarGraficoMensal = async () => {
    chartMensalError.value = false;
    loadingGraficoMensal.value = true;

    try {
        await redacaoStatsStore.fetchEstatisticasMensais();
    } catch (error) {
        chartMensalError.value = true;
        console.error('Erro ao recarregar estatísticas mensais:', error);
    } finally {
        loadingGraficoMensal.value = false;
    }
};

// Função para lidar com erros do gráfico
const handleChartError = (error) => {
    if (isBenignApexChartsNavigationReason(error)) return;
    console.error('Erro ao renderizar o gráfico:', error);
    chartReady.value = false;
    chartError.value = true;
};

// Capturar erros gerais no componente
onErrorCaptured((err, instance, info) => {
    if (isBenignApexChartsNavigationReason(err)) {
        return false;
    }

    console.error(`Erro capturado no componente: ${err}`, info);

    if (info.includes('apex') || info.includes('chart')) {
        chartReady.value = false;
    }

    return false;
});

</script>

<style scoped>
.dashboard-coupon-prompt :deep(.coupon-prompt--card) {
    margin-bottom: 0;
}

.dashboard-main-row > .col-xl-4 > .row.layout-top-spacing:first-of-type {
    margin-top: 12px;
}

.card-dashboard {
    min-height: 20rem;
}


.status-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 4px;
}

.status-dot.yellow {
    background-color: #e2a03f;
}

.status-dot.green {
    background-color: #00c853;
}

/* Estilos para esqueletos de carregamento */
.skeleton-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px 0;
    min-height: 200px;
}

.skeleton-turma {
    display: flex;
    align-items: center;
    padding: 5px 20px;
    margin-bottom: 10px;
    border-radius: 8px;
    background-color: var(--skeleton-bg, #f0f0f0) !important;
    animation: skeleton-pulse 1.5s infinite ease-in-out;
}

.skeleton-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: var(--skeleton-color-2, #d0d0d0) !important;
    margin-right: 15px;
    flex-shrink: 0;
    animation: skeleton-pulse 1.5s infinite ease-in-out;
}

.skeleton-content {
    flex-grow: 1;
}

.skeleton-line {
    height: 12px;
    background-color: var(--skeleton-color-2, #d0d0d0) !important;
    border-radius: 4px;
    margin-bottom: 8px;
    animation: skeleton-pulse 1.5s infinite ease-in-out;
}

.skeleton-line-title {
    width: 60%;
    height: 16px;
}

.skeleton-line-info {
    width: 80%;
}

/* Esqueleto do gráfico (Suas correções) */
.skeleton-chart {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 230px;
    height: 230px;
    width: 100%;
    padding: 20px;
}

.skeleton-donut {
    position: relative;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background: linear-gradient(90deg, var(--skeleton-color-2, #d0d0d0) 25%, var(--skeleton-color-1, #e8e8e8) 50%, var(--skeleton-color-2, #d0d0d0) 75%) !important;
    background-size: 200% 100%;
    animation: skeleton-shimmer 2s infinite ease-in-out;
    margin-bottom: 25px;
}

.skeleton-donut-hole {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: var(--skeleton-bg-color, #ffffff);
}

.skeleton-legend {
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 20px;
}

.skeleton-legend-item {
    width: 80px;
    height: 20px;
    background-color: var(--skeleton-color-2, #d0d0d0) !important;
    border-radius: 4px;
    animation: skeleton-pulse 1.5s infinite ease-in-out;
}

/* Skeleton para saldo */
.skeleton-saldo {
    width: 100%;
    height: 24px;
    background-color: var(--skeleton-color-2);
    border-radius: 4px;
    animation: skeleton-pulse 1.5s infinite ease-in-out;
    margin: 8px 0;
}

.skeleton-saldo .skeleton-line-title {
    width: 80px;
    height: 100%;
    background-color: var(--skeleton-color-1);
    border-radius: 4px;
    animation: skeleton-pulse 1.5s infinite ease-in-out;
}

/* Skeleton melhorado para valores de saldo */
.skeleton-saldo-value {
    width: 120px;
    height: 28px;
    background: linear-gradient(90deg, var(--skeleton-color-2, #d0d0d0) 25%, var(--skeleton-color-1, #e8e8e8) 50%, var(--skeleton-color-2, #d0d0d0) 75%) !important;
    background-size: 200% 100%;
    border-radius: 6px;
    animation: skeleton-shimmer 2s infinite ease-in-out;
}

.skeleton-saldo-amount {
    width: 80px;
    height: 20px;
    background: linear-gradient(90deg, var(--skeleton-color-2, #d0d0d0) 25%, var(--skeleton-color-1, #e8e8e8) 50%, var(--skeleton-color-2, #d0d0d0) 75%) !important;
    background-size: 200% 100%;
    border-radius: 4px;
    animation: skeleton-shimmer 2s infinite ease-in-out;
    margin: 10px auto 0;
}

/* Esqueleto para gráfico de área (Estatísticas de redações) – igual ao Estatísticas de inscritos nos cursos */
.skeleton-area-chart-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 230px;
    padding: 20px;
    width: 100%;
}

.skeleton-area-chart {
    width: 100%;
    height: 100%;
}

.skeleton-chart-svg {
    width: 100%;
    height: 100%;
}

/* Modo escuro para skeleton do gráfico */
[data-bs-theme="dark"] .skeleton-area-chart {
    color: #4a5568;
}

body:not(.dark):not([data-bs-theme="dark"]) .skeleton-area-chart {
    color: #c0c0c0;
}

/* Altura mínima para widgets com skeleton - evita mudança de tamanho */
.widget-skeleton-container {
    min-height: 300px !important;
    height: auto;
}

.widget-skeleton-container.widget-sales-category {
    height: 290px !important;
    min-height: 290px !important;
    max-height: 290px !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.widget-skeleton-container.widget-revenue {
    height: 290px !important;
    min-height: 290px !important;
    max-height: 290px !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.widget-skeleton-container .widget-content {
    min-height: 250px !important;
}

.widget-skeleton-container.widget-sales-category .widget-content {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.widget-skeleton-container.widget-revenue .widget-content {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

/* Altura fixa: os três cards sempre do mesmo tamanho (também durante o carregamento) */
.dashboard-card-equal {
    height: 350px;
    max-height: 350px;
    min-height: 350px;
}
.dashboard-card-equal :deep(.widget) {
    height: 100% !important;
    max-height: 100% !important;
    min-height: 100% !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.dashboard-card-equal :deep(.widget .widget-content) {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

/* Turmas recentes: mesma altura fixa */
.widget.widget-transaction.dashboard-card-equal {
    height: 350px !important;
    max-height: 350px !important;
    min-height: 350px !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.widget.widget-transaction.dashboard-card-equal .widget-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}
/* Durante o skeleton, esconde a barra de rolagem */
.widget.widget-transaction.dashboard-card-equal.is-loading-turmas .widget-content {
    overflow: hidden;
}

.widget.widget-sales-category {
    height: 290px !important;
    min-height: 290px !important;
    max-height: 290px !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.widget.widget-revenue {
    height: 290px !important;
    min-height: 290px !important;
    max-height: 290px !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* Garantir que widget-content mantenha altura mínima (exceto Turmas recentes que usa flex + scroll) */
.widget.widget-transaction:not(.dashboard-card-equal) .widget-content {
    min-height: 250px !important;
}

.widget.widget-sales-category .widget-content {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

/* Gráfico Suas correções: menos espaço entre donut e legenda */
.chart-container-correcoes {
    padding-top: 0;
    padding-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.chart-container-correcoes :deep(.apexcharts-legend) {
    padding-top: 4px !important;
}
.chart-container-correcoes :deep(.apexcharts-canvas) {
    margin-bottom: 0;
}

.widget.widget-revenue .widget-content {
    min-height: 200px !important;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

/* Variáveis CSS para modo claro/escuro */
:root {
    --skeleton-color-1: #e8e8e8;
    --skeleton-color-2: #d0d0d0;
    --skeleton-bg: #f0f0f0;
    --skeleton-bg-color: #ffffff;
}

[data-bs-theme="dark"] {
    --skeleton-color-1: #2d3748;
    --skeleton-color-2: #4a5568;
    --skeleton-bg: #1e293b;
    --skeleton-bg-color: #0f172a;
}

/* Garantir que skeletons sejam visíveis no modo light */
.widget {
    --skeleton-color-1: #e8e8e8;
    --skeleton-color-2: #d0d0d0;
    --skeleton-bg: #f0f0f0;
}

.dark .widget,
[data-bs-theme="dark"] .widget {
    --skeleton-color-1: #2d3748;
    --skeleton-color-2: #4a5568;
    --skeleton-bg: #1e293b;
}

/* Forçar visibilidade dos skeletons no modo light com cores mais escuras */
body:not(.dark):not([data-bs-theme="dark"]) .skeleton-circle,
body:not(.dark):not([data-bs-theme="dark"]) .skeleton-line,
body:not(.dark):not([data-bs-theme="dark"]) .skeleton-legend-item {
    background-color: #c0c0c0 !important;
}

body:not(.dark):not([data-bs-theme="dark"]) .skeleton-turma {
    background-color: #f5f5f5 !important;
}

body:not(.dark):not([data-bs-theme="dark"]) .skeleton-donut {
    background: linear-gradient(90deg, #c0c0c0 25%, #d5d5d5 50%, #c0c0c0 75%) !important;
    background-size: 200% 100%;
}

body:not(.dark):not([data-bs-theme="dark"]) .skeleton-saldo-value,
body:not(.dark):not([data-bs-theme="dark"]) .skeleton-saldo-amount {
    background: linear-gradient(90deg, #c0c0c0 25%, #d5d5d5 50%, #c0c0c0 75%) !important;
    background-size: 200% 100%;
}

/* Animações para skeletons */
@keyframes skeleton-pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.6;
    }
}

@keyframes skeleton-shimmer {
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
}

/* Correção para alinhamento à esquerda */
.wallet-balance .d-flex.flex-column.text-start {
    text-align: left !important;
    align-items: flex-start !important;
}

.wallet-balance .d-flex.flex-column.text-start p {
    text-align: left !important;
}

.no-data-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    width: 100%;
    padding: 20px;
    color: #666;
    font-size: 16px;
    text-align: center;
}

/* Estilos para estado vazio melhorado */
.empty-state-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    width: 100%;
    padding: 30px 20px;
    text-align: center;
}

/* Turmas recentes e cards de mesma altura: estado vazio ocupa toda a área e centraliza */
.widget.widget-transaction.dashboard-card-equal .widget-content .empty-state-container {
    flex: 1;
    min-height: 0;
}
.dashboard-card-equal :deep(.widget-corrections-queue .empty-state-container) {
    flex: 1;
    min-height: 0;
}

.empty-state-content {
    max-width: 350px;
    width: 100%;
}

.empty-state-icon {
    margin-bottom: 16px;
    color: #9ca3af;
    opacity: 0.8;
    display: flex;
    justify-content: center;
    align-items: center;
}

.empty-state-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
    line-height: 1.4;
}

.empty-state-description {
    color: #6b7280;
    font-size: 0.9rem;
    line-height: 1.4;
    margin-bottom: 20px;
}

.empty-state-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    font-weight: 500;
    font-size: 0.9rem;
    border-radius: 6px;
    transition: all 0.2s ease;
    text-decoration: none;
    border: none;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.empty-state-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.empty-state-button:active {
    transform: translateY(0);
}

/* Estilos específicos para estado vazio do gráfico */
.empty-state-chart {
    min-height: 200px;
    padding: 0px 20px;
}

.empty-state-chart .empty-state-icon {
    margin-bottom: 20px;
}

.empty-state-chart .empty-state-icon svg {
    opacity: 0.6;
    color: #9ca3af;
    transition: all 0.3s ease;
}

.empty-state-chart:hover .empty-state-icon svg {
    opacity: 0.8;
    transform: scale(1.05);
}

.empty-state-chart .empty-state-title {
    font-size: 1.15rem;
    margin-bottom: 10px;
}

.empty-state-chart .empty-state-description {
    font-size: 0.95rem;
    line-height: 1.5;
    margin-bottom: 0;
}

/* Modo escuro */
[data-bs-theme="dark"] .empty-state-title {
    color: #f3f4f6;
}

[data-bs-theme="dark"] .empty-state-description {
    color: #9ca3af;
}

[data-bs-theme="dark"] .empty-state-icon {
    color: #6b7280;
}

[data-bs-theme="dark"] .empty-state-chart .empty-state-icon svg {
    color: #6b7280;
}

.chart-error-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    width: 100%;
    padding: 20px;
    color: #666;
    font-size: 16px;
    text-align: center;
    background-color: #fef8f8;
    border-radius: 8px;
}

.chart-error-container p {
    margin-bottom: 0;
}

.chart-error-container button {
    margin-left: 10px;
}

.transactions-list {
    border: 1px solid #e0e0e065;
    border-radius: 10px;
    padding: 8px;
    margin-bottom: 5px !important;
    margin-top: 0px;
}

.transactions-list:hover {
    border-radius: 10px;
    border: 1px solid #e0e0e0;
    padding: 8px;
    margin-bottom: 10px;
}




/* Estilos para dropdown de período de correções */
#checkPeriodoCorrecoes + .dropdown-menu .dropdown-item.active {
    background-color: #f1f2f3;
    color: #4361ee;
    font-weight: 600;
}

#checkPeriodoCorrecoes + .dropdown-menu .dropdown-item.active svg {
    color: #4361ee;
}

[data-bs-theme="dark"] #checkPeriodoCorrecoes + .dropdown-menu .dropdown-item.active,
.dark #checkPeriodoCorrecoes + .dropdown-menu .dropdown-item.active,
body.dark #checkPeriodoCorrecoes + .dropdown-menu .dropdown-item.active {
    background-color: #1b2e4b;
    color: #4361ee;
}

[data-bs-theme="dark"] #checkPeriodoCorrecoes + .dropdown-menu .dropdown-item.active svg,
.dark #checkPeriodoCorrecoes + .dropdown-menu .dropdown-item.active svg,
body.dark #checkPeriodoCorrecoes + .dropdown-menu .dropdown-item.active svg {
    color: #4361ee;
}

</style>
